import React from 'react'
import _ from 'lodash'
import '../../styles/scss/elements/hero.scss'

import HeroDetailsAmtrak from './elements/HeroDetailsAmtrak'
import HeroDetailsRailbookers from './elements/HeroDetailsRailbookers'
import HeroSlider from './elements/HeroSlider';

import { isRailBookers } from '../../configuration/brand'

const HeroDetails  = isRailBookers() ? HeroDetailsRailbookers : HeroDetailsAmtrak

const Hero = props => {
  const {
    tourId,
    brand,
    containerClasses,
    backgroundImage,
    discountText,
    heroImages,
    title,
    tags,
    numCountries,
    numDays,
    numDestinations,
    price,
    roundTripUpgradePrice,
    cta
  } = props

  const sliderImages = backgroundImage
    ? _.concat(backgroundImage, heroImages)
    : heroImages

  return (
    <div className={ containerClasses ? containerClasses : 'hero' }>
      <div className='hero__image-container'>
        <HeroSlider images={sliderImages} />
      </div>
      <HeroDetails
        tourId={tourId}
        brand={brand}
        discountText={discountText}
        title={title}
        tags={tags}
        numCountries={numCountries}
        numDays={numDays}
        numDestinations={numDestinations}
        price={price}
        roundTripUpgradePrice={roundTripUpgradePrice}
        cta={cta}
      />
    </div>
  )
}

export default Hero
